import { render, staticRenderFns } from "./ShowOrders.vue?vue&type=template&id=3799471a&scoped=true&"
import script from "./ShowOrders.vue?vue&type=script&lang=js&"
export * from "./ShowOrders.vue?vue&type=script&lang=js&"
import style0 from "./ShowOrders.vue?vue&type=style&index=0&id=3799471a&scoped=true&lang=css&"
import style1 from "./ShowOrders.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3799471a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VContainer,VRow,VSelect})
